export default {
  oldPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  },
  newPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 8,
      maximum: 128
    }
  },
  confirmPassword: {
    presence: { allowEmpty: false, message: 'is required' },
    equality: {
      attribute: "newPassword",
      message: "is not matching",
      comparator: function(v1, v2) {
        return v1 === v2;
      }
    },
    length: {
      minimum: 8,
      maximum: 128
    }
  },
};